import { render } from "./DownloadPDFButton.vue?vue&type=template&id=71cb459a"
import script from "./DownloadPDFButton.vue?vue&type=script&lang=js"
export * from "./DownloadPDFButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__